export default __webpack_public_path__ + "static/media/ui.eaf9a0a2.png";